import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid, scopedCssBaselineClasses, Container } from '@mui/material'
import { findCode, printVariable } from '@util/helper'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import { useMediaQuery } from '@mui/material'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
import MyTableHead from '@components/MyTableHead'
import ConfirmDialog from '@components/ConfirmDialog'
import useAlert from '@hooks/useAlert'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import Box from '@mui/material/Box'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import '@scss/App.scss'
import consoleLogger from 'react-terminal-logger/console-logger'
import CloseIcon from '@mui/icons-material/Close'
import { useTheme } from '@mui/material/styles';
import { LineCart, LineChart, } from '@mui/x-charts/LineChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';
import { useAnimate, useAnimateBar, useDrawingArea } from '@mui/x-charts/hooks';
import { PiecewiseColorLegend } from '@mui/x-charts/ChartsLegend';
import { interpolateObject } from '@mui/x-charts-vendor/d3-interpolate';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ManagerSurveyPartIndi = ({ record, dialogHandler, tabValue, callback }) => {
  const [quests, set_quests] = useState([])
  const [surveySum, set_surveySum] = useState([])
  const [openSnackbar] = useSnackbar()
  const [replUserCnt, set_replUserCnt] = useState()
  const [subjRepls, set_subjRepls] = useState([])
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [data, set_data] = useState({
    headers: [],
    rows: [],
  })

  const schola = useSelector(state => state.scholaReducer);
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    else {
      dialogHandler[1](false)
    }
  }


  const transformToMatrix = (respData) => {
    const { questArray, ansArray, userReplArray } = respData
    
    // 선택지 정보 조회를 위한 Map 생성
    const ansMap = new Map(ansArray.map(a => [a.id, a]))

    const rows = userReplArray.map(user => {
      // 1. 질문 ID별로 응답들을 그룹화 (복수 응답 대응)
      const replGroupMap = new Map()
      user.repls.forEach(r => {
        if (!replGroupMap.has(r.questId)) {
          replGroupMap.set(r.questId, [])
        }
        replGroupMap.get(r.questId).push(r)
      })

      const cells = questArray.map(q => {
        const repls = replGroupMap.get(q.id)
        if (!repls || repls.length === 0) return { type: 'NONE', value: '-' }

        // 2. 여러 개의 응답을 순회하며 텍스트 추출 및 합치기
        const values = repls.map(repl => {
          const ansOption = ansMap.get(repl.ansId)
          return ansOption ? ansOption.txt : (repl.txt || '')
        })

        return {
          questId: q.id,
          // 응답이 여러 개면 콤마(,)로 연결하여 표시
          value: values.join(', '),
          type: repls[0].ansId !== -1 ? 'OBJECTIVE' : 'SUBJECTIVE',
          count: repls.length // 복수 응답 개수 확인용
        }
      })

      return {
        userId: user.user.phone,
        data: cells
      }
    })

    return { headers: questArray.map(q => q.txt), rows: rows }
}


  const fetchSurveyDetail = async () => {
    const url = `/survey/detail/${record.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    console.log('repMessage=>',repMessage )
    console.log('surveyDetail=>', repMessage.surveyDetail)
    const surveyDetail = JSON.parse(repMessage.surveyDetail)
    

    const { headers, rows } = transformToMatrix(surveyDetail)
    set_data({
      headers: headers,
      rows: rows,
    })

  }

  const onLoad = async () => {
    await fetchSurveyDetail()
  }

  useEffect(() => {
    console.log('data=>', data)
  }, [data])

  useEffect(() => {
    onLoad()
  }, [])
  return (
    <Fragment>
      <div>
        {renderIndicator()}
        {renderAlert()}

      </div>
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='lg'>
        <DialogTitle>
          <Grid container>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', textAlign:'center' }}>
                  설문 상세 응답 현황 (개별)
                </Typography>

                {/* 테이블 가로 스크롤을 위한 Box 래퍼 */}
                <Box sx={{ width: '100%', overflowX: 'auto', boxShadow: 1, borderRadius: 1 }}>
                  <MUITable stickyHeader aria-label="survey response matrix">
                    <TableHead>
                      <TableRow>
                        {/* 첫 번째 컬럼은 사용자 ID 고정 */}
                        <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', minWidth: 100 }}>
                          순번(전화번호)
                        </TableCell>
                        {/* 질문 헤더 나열 */}
                        {data.headers.map((header, index) => (
                          <TableCell key={index} align="center" sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', minWidth: 150 }}>
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        data.rows.length > 0 ? (
                          data.rows.map((row, rowIndex) => (
                            <TableRow key={rowIndex} hover>
                              <TableCell sx={{ fontWeight: 'medium' }}>
                                {rowIndex + 1} ({row.userId})
                              </TableCell>
                              {/* 사용자별 응답 셀 나열 */}
                              {row.data.map((cell, cellIndex) => (
                                <TableCell key={cellIndex} align="center">
                                  <Typography variant="body2" color={cell.type === 'NONE' ? 'text.disabled' : 'text.primary'}>
                                    {cell.value}
                                  </Typography>
                                  {/* 객관식/주관식 구분이 필요할 경우 작은 칩이나 아이콘 추가 가능 */}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                        ) : (
                          // <TableRow>
                          //   <TableCell colSpan={data.headers.length + 1} align="center" sx={{ py: 3 }}>
                          //     응답 데이터가 없습니다.
                          //   </TableCell>
                          // </TableRow>
                          <></>
                        )
                      }
                    </TableBody>
                  </MUITable>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </DialogContent>
        <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={handleClose}>닫기</Button>
        </DialogActions>
      </Dialog>

    </Fragment>
  )
}

export default ManagerSurveyPartIndi